//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import { NavLink } from "react-router-dom";
import cx from "classnames";
import Person from "@material-ui/icons/Person";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";

// core components
import HeaderLinks from "components/EnergyCompany/Header/HeaderLinks.jsx";
import SidebarWrapper from "./SidebarWrapper.jsx";

import sidebarStyle from "assets/jss/material-dashboard-pro-react/components/sidebarStyle.jsx";

import { isEmpty, map } from "lodash";
import { internalRoutes } from "routes/dashboard.jsx";

// import avatar from "assets/EnergyCompany/img/default-avatar.png";

const styles = theme => {
  const originalSidebarStyle = { ...sidebarStyle(theme) };

  return {
    ...originalSidebarStyle,
    logoMini: {
      ...originalSidebarStyle.logoMini,
      marginTop: 0,
    },
    photo: {
      ...originalSidebarStyle.photo,
      alignItems: "center",
      boxShadow: "none",
      display: "flex",
      marginRight: "0",
    },
    userCollapseLinks: {
      ...originalSidebarStyle.userCollapseLinks,
      "&:hover,&:focus": {
        color: "inherit",
      },
    },
  };
};

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      miniActive: true,
    };
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname === routeName ? true : false;
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }
  render() {
    const {
      bgColor,
      classes,
      color,
      image,
      logo,
      logoText,
      routes,
      userInfo,
    } = this.props;
    const itemText = classes.itemText + " " + cx({ [classes.itemTextMini]: this.props.miniActive && this.state.miniActive });
    const collapseItemText = classes.collapseItemText + " " + cx({ [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive });
    const userWrapperClass = classes.user + " " + cx({ [classes.whiteAfter]: bgColor === "white" });
    const caret = classes.caret;
    const collapseItemMini = classes.collapseItemMini;
    const photo = classes.photo;
    var user = !isEmpty(userInfo) ? (
      <div className={userWrapperClass}>
        <div className={photo}>
          {/* <img alt="..." className={classes.avatarImg} src={avatar} /> */}
          <Person />
        </div>
        <List className={classes.list}>
          <ListItem className={classes.item + " " + classes.userItem}>
            <NavLink
              className={classes.itemLink + " " + classes.userCollapseButton}
              onClick={() => this.openCollapse("openAvatar")}
              to={"#"}
            >
              <ListItemText
                className={itemText + " " + classes.userItemText}
                disableTypography={true}
                primary={this.props.userInfo.nome}
                secondary={
                  <b
                    className={
                      caret + " " + classes.userCaret +
                      " " +
                      (this.state.openAvatar ? classes.caretActive : "")
                    }
                  />
                }
              />
            </NavLink>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List className={classes.list + " " + classes.collapseList}>
                <ListItem className={classes.collapseItem}>
                  {map(internalRoutes, (route, index) => (
                    <NavLink className={classes.itemLink + " " + classes.userCollapseLinks} key={index} to={route.path}>
                      <span className={collapseItemMini}>
                        {route.mini}
                      </span>
                      <ListItemText
                        className={collapseItemText}
                        disableTypography={true}
                        primary={route.name}
                      />
                    </NavLink>
                  ))}
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </div>
    ) : undefined;
    var links = (
      <List className={classes.list}>
        {routes.map((prop, key) => {
          if (prop.redirect) {
            return null;
          }
          if (prop.collapse) {
            const navLinkClasses =
              classes.itemLink +
              " " +
              cx({ [" " + classes.collapseActive]: this.activeRoute(prop.path) });
            const itemText = classes.itemText + " " + cx({ [classes.itemTextMini]: this.props.miniActive && this.state.miniActive });
            const collapseItemText = classes.collapseItemText + " " + cx({ [classes.collapseItemTextMini]: this.props.miniActive && this.state.miniActive });
            const itemIcon = classes.itemIcon;
            const caret = classes.caret;
            return (
              <ListItem className={classes.item} key={key}>
                <NavLink
                  className={navLinkClasses}
                  onClick={() => this.openCollapse(prop.state)}
                  to={"#"}
                >
                  <ListItemIcon className={itemIcon}>
                    <prop.icon />
                  </ListItemIcon>
                  <ListItemText
                    className={itemText}
                    disableTypography={true}
                    primary={prop.name}
                    secondary={
                      <b
                        className={
                          caret +
                          " " +
                          (this.state[prop.state] ? classes.caretActive : "")
                        }
                      />
                    }
                  />
                </NavLink>
                <Collapse in={this.state[prop.state]} unmountOnExit>
                  <List className={classes.list + " " + classes.collapseList}>
                    {prop.views.map((prop, key) => {
                      if (prop.redirect) {
                        return null;
                      }
                      const navLinkClasses =
                        classes.collapseItemLink +
                        " " +
                        cx({ [" " + classes[color]]: this.activeRoute(prop.path) });
                      const collapseItemMini = classes.collapseItemMini;
                      return (
                        <ListItem className={classes.collapseItem} key={key}>
                          <NavLink className={navLinkClasses} to={prop.path}>
                            <span className={collapseItemMini}>
                              {prop.mini}
                            </span>
                            <ListItemText
                              className={collapseItemText}
                              disableTypography={true}
                              primary={prop.name}
                            />
                          </NavLink>
                        </ListItem>
                      );
                    })}
                  </List>
                </Collapse>
              </ListItem>
            );
          }
          const navLinkClasses =
            classes.itemLink +
            " " +
            cx({ [" " + classes[color]]: this.activeRoute(prop.path) });
          const itemText = classes.itemText + " " + cx({ [classes.itemTextMini]: this.props.miniActive && this.state.miniActive });
          const itemIcon = classes.itemIcon;
          return (
            <ListItem className={classes.item} key={key}>
              <NavLink className={navLinkClasses} to={prop.path} >
                <ListItemIcon className={itemIcon}>
                  <prop.icon />
                </ListItemIcon>
                <ListItemText
                  className={itemText}
                  disableTypography={true}
                  primary={prop.name}
                />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );

    const logoNormal = classes.logoNormal + " " + cx({ [classes.logoNormalSidebarMini]: this.props.miniActive && this.state.miniActive });
    const logoMini = classes.logoMini;
    const logoClasses = classes.logo + " " + cx({ [classes.whiteAfter]: bgColor === "white" });
    var brand = (
      <div className={logoClasses}>
        <a className={logoMini} href="/">
          <img alt="logo" className={classes.img} src={logo} />
        </a>
        <a className={logoNormal} href="/">
          {logoText}
        </a>
      </div>
    );
    const drawerPaper = classes.drawerPaper + " " + cx({ [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive });
    const sidebarWrapper =
      classes.sidebarWrapper +
      " " +
      cx({
        [classes.drawerPaperMini]: this.props.miniActive && this.state.miniActive,
        [classes.sidebarWrapperWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1,
      });
    return (
      <div>
        <Hidden mdUp>
          <Drawer
            anchor={"right"}
            classes={{ paper: drawerPaper + " " + classes[bgColor + "Background"] }}
            ModalProps={{ keepMounted: true }} // Better open performance on mobile.
            onClose={this.props.handleDrawerToggle}
            open={this.props.open}
            variant="temporary"
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              headerLinks={<HeaderLinks />}
              links={links}
              user={user}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            anchor={"left"}
            classes={{ paper: drawerPaper + " " + classes[bgColor + "Background"] }}
            onMouseOut={() => this.setState({ miniActive: true })}
            onMouseOver={() => this.setState({ miniActive: false })}
            open
            variant="permanent"
          >
            {brand}
            <SidebarWrapper
              className={sidebarWrapper}
              links={links}
              user={user}
            />
            {image !== undefined ? (
              <div
                className={classes.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "white",
  userInfo: {},
};

Sidebar.propTypes = {
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["white", "red", "orange", "green", "blue", "purple", "rose"]),
  handleDrawerToggle: PropTypes.func,
  image: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  logo: PropTypes.string,
  logoText: PropTypes.string,
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  userInfo: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default withStyles(styles)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Sidebar/Sidebar.jsx